// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"P_dn","categories__list":"P_dp"};